import { createRpcClientV2 } from 'rpc-client-utils';
import apiClient from 'hub-http/clients/apiClient';
import { getStatusRpc, updateStatusRpc, deleteStatusRpc } from '../../__generated__/chirp/com/hubspot/coaching/tips/rpc/StatusRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: apiClient
});
export const getOnboardingBeaconDismissStatus = onboardingBeaconId => rpcClient.call(getStatusRpc, {
  request: {
    coachingTipId: onboardingBeaconId
  }
}).then(response => response.result.dismissed);
export const setOnboardingBeaconDismissStatus = onboardingBeaconId => rpcClient.call(updateStatusRpc, {
  request: {
    coachingTipRequest: {
      coachingTipId: onboardingBeaconId
    }
  }
});
export const restoreOnboardingBeacon = onboardingBeaconId => rpcClient.call(deleteStatusRpc, {
  request: {
    coachingTipId: onboardingBeaconId
  }
});